<div class="container landing-container listing-page-wrapper">
  <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb" class="breadcrumb-block d-none d-lg-block">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="city?.city">{{city?.city}}</li>
      <li class="breadcrumb-item" aria-current="page">Restaurants</li>
    </ol>
  </nav>
  <div class="row">
    <div class="col-lg order-1 order-lg-0" #listSheet>
      <div class="view-change-wrap d-md-none">
        <ul>
          <li>
            <button class="btn btn-icon" (click)="toggleLineView()" [ngClass]="gridView ? '' : 'active'">
              <img src="./assets/images/ic-grid-view.svg" alt="Icon" />
            </button>
          </li>
          <li>
            <button class="btn btn-icon" (click)="toggleGridView()" [ngClass]="gridView ? 'active' : ''">
              <img src="./assets/images/ic-line-view.svg" alt="Icon" />
            </button>
          </li>
        </ul>
      </div>
      <div class="restaurants-tab-outer main-layout" [ngClass]="gridView ? 'grid-view' : ''">
        <ul ngbNav #dishNav="ngbNav" [(activeId)]="activePanel" class="nav-tabs">
          <li [ngbNavItem]="1">
            <button ngbNavLink>Popular</button>
            <ng-template ngbNavContent>
              <app-restaurant-detail-section [businessFilter]="filter" (onListLoad)="updateResturantCoordinates($event)" (loadFailed)="listingSearch.onListLoadFailed()" (loadCompleted)="listingSearch.onListLoadCompleted($event)" (pinWindowChange)="pinWindow = $event" [searchIds]="searchIds"
                                             [gridView]="gridView" [restaurantListType]="activePanel" [center]="currentCenter" [isCall]="!isLoading && !locationUnavailable"></app-restaurant-detail-section>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <button ngbNavLink>Open Now</button>
            <ng-template ngbNavContent>
              <app-restaurant-detail-section [businessFilter]="filter" (onListLoad)="updateResturantCoordinates($event)" (loadFailed)="listingSearch.onListLoadFailed()" (loadCompleted)="listingSearch.onListLoadCompleted($event)" (pinWindowChange)="pinWindow = $event" [searchIds]="searchIds"
                                             [gridView]="gridView" [restaurantListType]="activePanel" [center]="currentCenter" [isCall]="!isLoading && !locationUnavailable"></app-restaurant-detail-section>
            </ng-template>
          </li>
          <li [ngbNavItem]="3">
            <button ngbNavLink>Delivery</button>
            <ng-template ngbNavContent>
              <app-restaurant-detail-section [businessFilter]="filter" (onListLoad)="updateResturantCoordinates($event)" (loadFailed)="listingSearch.onListLoadFailed()" (loadCompleted)="listingSearch.onListLoadCompleted($event)" (pinWindowChange)="pinWindow = $event" [searchIds]="searchIds"
                                             [gridView]="gridView" [restaurantListType]="activePanel" [center]="currentCenter" [isCall]="!isLoading && !locationUnavailable"></app-restaurant-detail-section>
            </ng-template>
          </li>
          <li [ngbNavItem]="4">
            <button ngbNavLink>Nearby</button>
            <ng-template ngbNavContent>
              <app-restaurant-detail-section [businessFilter]="filter" (onListLoad)="updateResturantCoordinates($event)" (loadFailed)="listingSearch.onListLoadFailed()" (loadCompleted)="listingSearch.onListLoadCompleted($event)" (pinWindowChange)="pinWindow = $event" [searchIds]="searchIds"
                                             [gridView]="gridView" [restaurantListType]="activePanel" [center]="currentCenter" [isCall]="!isLoading && !locationUnavailable"></app-restaurant-detail-section>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="dishNav" class="mt-2"></div>
      </div>
    </div>
    <div class="col-lg-6 order-0 order-lg-1 location-col">
      <app-listing-search #listingSearch [tourLocation]="tourLocation" [resturantCoordinates]="resturantCoordinates" [isSearchBarActive]="isSearchBarActive" (showSearchChanges)="showSearchChanges($event)"
                          [pinWindow]="pinWindow"
                          (filterChanges)="filterChanges($event)" (cityEmitted)="cityEmitted($event)" (centerChange)="onCenterChange($event)"></app-listing-search>
    </div>
  </div>
</div>
